<template>
    <div class="maincontain">
        <el-container>
            <el-header class="elheader">
                <CommonHeader></CommonHeader>
            </el-header>
            <el-main>
                    <KeepAlive>
                        <router-view v-if="$route.meta.KeepAlive"></router-view>
                    </KeepAlive>
                    <router-view  v-if="!$route.meta.KeepAlive"></router-view>
                </el-main>
                <el-footer>
                    <CommonFooter/>
                </el-footer>
        </el-container>
        
    </div>
</template>

<script>
import CommonFooter from "../components/CommonFooter.vue";
import CommonHeader from "../components/CommonHeader.vue";

export default {
    name: "MainView",
    data() {
        return {};
    },
    components: { CommonFooter, CommonHeader },
    mounted() {
        document.title = '大洲玉文化创意园'
    },
};
</script>

<style lang="less" scoped>
.maincontain {
    display: flex;
    .elheader {
        padding: 0;
        height: 14.58vw !important; 
        min-height: 140px;
        max-height: 180px;
    }
    .el-main {
        padding:0;
        margin-top: 1px;
        // position: absolute;
        // top: 80px;
        left: 0; //侧边栏宽度
        right: 0;
        bottom: 0;
        overflow: visible;
    }

    .el-footer {
        padding: 0;
        background-color: antiquewhite;
    }
}
</style>